import React from "react";
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

import { withRouter } from 'react-router-dom';
import withCurrentUser from '../../../../hocs/with_current_user.js';
import withShowToast from '../../../../hocs/with_show_toast.js';
import withShowModal from '../../../../hocs/with_show_modal.js';
import { compose } from 'redux';

import pageStyles from "../../../styles/page_styles.js";
import { infoPageStyles } from "../../base_info_page.js";

import I18n from "../../../../base/i18n.js";

import BaseInfoPage from "../../base_info_page.js";
import Button from "../../../../base/buttons/button.js";

import { ProjectDeveloperModel } from "../../../../models/projects/project_developer_model.js";

import ShowDeveloperUseCase from "../../../../use_cases/admin/projects/developers/show_developer_use_case.js";
import SaveDeveloperUseCase from "../../../../use_cases/admin/projects/developers/save_developer_use_case.js";
import DeleteDeveloperUseCase from "../../../../use_cases/admin/projects/developers/delete_developer_use_case.js";

import Routes from "../../../routes.js";

const styles = theme => ({
});

class DeveloperInfoPage extends BaseInfoPage {

  loadItem() {
    if(this.identifier) {
      this.processDataLoader(this.showUseCase.execute(this.identifier));
    }
    else {
      this.item.key = "newItem";
      this.setState({
        loading: false
      });
    }
  }

  deleteConfirmMessage() {
    return I18n.t("admin.projects.developer.delete.confirm_message", {
      name: this.dataModel.displayValue(this.item)
    });
  }

  processLoadedItem(result) {
    const { data: { developer } } = result;
    this.item = developer;
  }

  rightButtons() {
    const { classes } = this.props;
    const { submit, loading } = this.state;

    return <React.Fragment>
      {
        this.identifier &&
          <Button className = { clsx(classes.formButton, classes.delete) }
                disabled = { submit || loading }
                onClick = { this.onDelete } >
          { I18n.t("action.delete") }
        </Button>
      }
    </React.Fragment>
  }
}

DeveloperInfoPage.defaultProps = {
  dataModel: ProjectDeveloperModel,
  showUseCase: ShowDeveloperUseCase,
  saveUseCase: SaveDeveloperUseCase,
  deleteUseCase: DeleteDeveloperUseCase,
  routeFunc: Routes.developer
}

export default compose(
  withRouter, 
  withShowToast, 
  withCurrentUser, 
  withShowModal,
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...infoPageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(DeveloperInfoPage);
